import { Link } from 'react-router-dom';

export default function AnnouncementBanner() {
  return (
    <div className="relative z-50 flex items-center border-b border-border px-6 py-2.5 sm:px-8">
      <p className="text-lg tracking-wider">
        {/* <strong className="mr-2 inline-block">
          🎉{' '}
          <Link to="/points" className="text-primary underline">
            Points
          </Link>{' '}
          are now live!
        </strong>{' '}
        <span>
          Trade to earn.
        </span> */}
        🎉 Now offering <strong>collateral on locked assets</strong>. Click{' '}
        <Link
          to="/portfolio?view=locked-asset-collateral"
          className="font-medium text-primary underline"
        >
          here
        </Link>{' '}
        to learn more or request collateral.
      </p>
    </div>
  );
}
